<template>
  <div class="fotter">
    <div class="w">
      <div>
        <template v-for="item in foList">
          <a href="javascript:;" :key="item.id" @click="goNew(item)">{{item.title}}</a>|&nbsp;
        </template>
        <p class="beian"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logoUlr: '',
      foList: []
    }
  },
  methods: {
    async queryNewList() {
      const { data: res } = await this.$http.get('api/index/getnewscate')
      let result = res.data
      for (let k in result) {
        for (let i = 0; i < result[k].list.length; i++) {
          this.foList.push(result[k].list[i])
        }
      }
    },
    goNew(item) {
      window.sessionStorage.setItem('n', item.title)
      this.$router.push('/newList?id=' + item.id)
    }
  },
  created() {
    this.queryNewList()
  }
}
</script>

<style lang="less" scoped>
.fotter {
  margin-top: 20px;
  .w div {
    font-size: 12px;
    text-align: center;
    a {
      color: #666;
      margin-right: 5px;
    }
    p {
      margin-top: 5px;
    }
  }
}
</style>
